import { useMemo } from 'react';

type PricesResult = {
    sellPrice: number;
    buyPrice: number;
    margin: number;
};

export function useTradingCalc({
    price,
    spread,
    volume,
    leverage,
}: {
    price: number;
    spread: number;
    volume: number;
    leverage: number;
}): PricesResult {
    return useMemo(() => {
        const base = Number(price) || 0;
        const s = Number(spread) / 100;

        const sellPrice = base * (1 - s);
        const buyPrice = base * (1 + s);

        const margin = (volume * base) / leverage;

        return {
            sellPrice,
            buyPrice,
            margin,
        };
    }, [price, spread, volume, leverage]);
}
